import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiServiceBase ,API_NAMES } from '../api';

@Injectable({
  providedIn: 'root'
})

export class PermissionsService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.administration);
  }

  getAllPermissions():Observable<any> {
    return this.http.get<any>(this._url());
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/permissions${v}`);
  }
}
